import { Link } from "react-router-dom";

function BreadcrumbRow({ items, showIndices = [] }) {
  const isShownOnMobile = (index) =>
    showIndices.length === 0 || showIndices.includes(index);

  return (
    <ol className="flex flex-wrap items-center gap-1 md:gap-2">
      {items.map((item, index) => (
        <li key={index} className={`${isShownOnMobile(index) ? 'inline-flex' : 'hidden md:inline-flex'} items-center`}>
          {item.link ? (
            <Link
              to={item.link}
              className="text-xs font-medium text-gray-600 dark:text-gray-300 sm:text-sm break-words"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-xs font-medium text-gray-800 dark:text-gray-100 sm:text-sm break-words">
              {item.label}
            </span>
          )}
        </li>
      ))}
    </ol>
  );
}

export default function Breadcrumb({ trail, showIndices = [], secondaryTrail = [] }) {
  return (
    <nav
      className="px-3 py-2 text-gray-700 border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-900 dark:border-gray-700 sm:px-5 sm:py-3"
      aria-label="Breadcrumb"
    >
      <BreadcrumbRow items={trail} showIndices={showIndices} />
      {secondaryTrail.length > 0 && (
        <BreadcrumbRow items={secondaryTrail} />
      )}
    </nav>
  );
}